import { dataDragIndicator } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDragIndicator = /*#__PURE__*/createIcon(dataDragIndicator)
export default IconDragIndicator
